import { Grid } from '@mui/material';

import { Contentful, FrontifyImageContent } from '@/contentful';
import useDeviceWidth from '@/hooks/deviceWidth';
import { getFrontifyBackgroundImageUrl } from '@/utils/frontify';

import useStyles from './HeroMidFullImage.styles';

export interface HeroMidFullImageContent extends Contentful {
  fields: {
    image: FrontifyImageContent[];
    mobileImage?: FrontifyImageContent[];
  };
}

interface Props {
  content: HeroMidFullImageContent;
}

export default function HeroMidFullImage({ content }: Props) {
  const { isMobile } = useDeviceWidth();
  const {
    fields: { image, mobileImage },
  } = content;
  const { classes } = useStyles();
  const backgroundImage =
    isMobile && mobileImage
      ? getFrontifyBackgroundImageUrl(mobileImage[0].preview_url, 768)
      : getFrontifyBackgroundImageUrl(image[0].preview_url, 1440);

  return (
    <Grid className={classes.heroSection} style={{ backgroundImage }}></Grid>
  );
}
